/**
 * GTIN/EAN aus Roh-Scan extrahieren (Whitespace entfernen).
 * Keine fachliche Prüfung der Prüfziffer — Shopware entscheidet.
 * @param {string} raw
 * @returns {string}
 */
export function normalizeGtin(raw) {
  if (raw == null) return '';
  return String(raw).trim();
}

/**
 * Grobe Plausibilität für reine Ziffern-Codes (8–14), optional führende Nullen.
 * @param {string} s
 */
export function looksLikeNumericGtin(s) {
  const t = normalizeGtin(s);
  if (!t) return false;
  return /^\d{8,14}$/.test(t);
}
